import { cn } from '@/lib/cn'

/**
 * Long-form styling for every MDX document — 17 posts and 23 support docs.
 *
 * The rules live in `.prose`, in `@layer components` in
 * src/styles/components.css. They used to be 24 Tailwind arbitrary variants
 * (`[&_h2]:mt-14`, `[&_blockquote]:border-l-[5px]`, …) in a single `cn()`
 * call here, which was CSS written in class strings: unreadable in review,
 * awkward to override, and impossible to diff against the Webflow rules that
 * style the same content on the ported pages.
 *
 * Those Webflow rules are in src/styles/site-custom.css and still serve the
 * ported pages until Phase 5 retires them. The two agree on every value —
 * `blockquote`'s 5px brand rule, the 16px/8px figure treatment, the 32px/16px
 * code block. The one place they had drifted was the figure border:
 * `border-black/10` resolved to 2% black, not 10%, because `--color-black` is
 * itself `#0003`.
 *
 * Base `h1`–`h6`, `p` and `li` still come from the element cascade in
 * globals.css; `.prose` only adds the rhythm and the block treatments.
 */
export function Prose({ children, className }: { children: React.ReactNode; className?: string }) {
  return <div className={cn('prose', className)}>{children}</div>
}
